var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-container" },
    [
      _c(
        "el-form",
        {
          ref: "loginForm",
          staticClass: "login-form",
          attrs: {
            model: _vm.loginForm,
            rules: _vm.loginRules,
            autocomplete: "on",
            "label-position": "left",
          },
        },
        [
          _c("div", { staticClass: "title-container" }, [
            _c("div", { staticClass: "icon", staticStyle: { float: "left" } }, [
              _c("img", {
                staticStyle: { "margin-right": "30px" },
                attrs: {
                  src: require("@/assets/otr/images/LifeHikes-logo-knocked-out.png"),
                  width: "135",
                  height: "35",
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "title" }, [_vm._v("Admin Portal")]),
          ]),
          _vm._v(" "),
          _vm.isProduction
            ? _c(
                "el-form-item",
                { attrs: { prop: "username" } },
                [
                  _c(
                    "span",
                    { staticClass: "svg-container" },
                    [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    ref: "username",
                    attrs: {
                      placeholder: "Click to login LifeHikes Office 365 ",
                      name: "username",
                      type: "text",
                      tabindex: "1",
                      autocomplete: "on",
                      readonly: "",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.handelUserNameClick($event)
                      },
                    },
                    model: {
                      value: _vm.loginForm.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.loginForm, "username", $$v)
                      },
                      expression: "loginForm.username",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.isProduction
            ? _c(
                "el-form-item",
                { attrs: { prop: "username" } },
                [
                  _c(
                    "span",
                    { staticClass: "svg-container" },
                    [_c("svg-icon", { attrs: { "icon-class": "user" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    ref: "username",
                    attrs: {
                      placeholder: "Username ",
                      name: "username",
                      type: "text",
                      tabindex: "1",
                      autocomplete: "on",
                    },
                    model: {
                      value: _vm.loginForm.username,
                      callback: function ($$v) {
                        _vm.$set(_vm.loginForm, "username", $$v)
                      },
                      expression: "loginForm.username",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-tooltip",
            {
              attrs: {
                content: "Caps lock is On",
                placement: "right",
                manual: "",
              },
              model: {
                value: _vm.capsTooltip,
                callback: function ($$v) {
                  _vm.capsTooltip = $$v
                },
                expression: "capsTooltip",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { prop: "password" } },
                [
                  _c(
                    "span",
                    { staticClass: "svg-container" },
                    [_c("svg-icon", { attrs: { "icon-class": "password" } })],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-input", {
                    key: _vm.passwordType,
                    ref: "password",
                    attrs: {
                      type: _vm.passwordType,
                      placeholder: "Password",
                      name: "password",
                      tabindex: "2",
                      autocomplete: "on",
                    },
                    on: {
                      blur: function ($event) {
                        _vm.capsTooltip = false
                      },
                    },
                    nativeOn: {
                      keyup: [
                        function ($event) {
                          return _vm.checkCapslock($event)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleLogin($event)
                        },
                      ],
                    },
                    model: {
                      value: _vm.loginForm.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.loginForm, "password", $$v)
                      },
                      expression: "loginForm.password",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "show-pwd", on: { click: _vm.showPwd } },
                    [
                      _c("svg-icon", {
                        attrs: {
                          "icon-class":
                            _vm.passwordType === "password"
                              ? "eye"
                              : "eye-open",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { width: "100%", "margin-bottom": "10px" },
              attrs: { loading: _vm.loading, type: "primary" },
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleLogin($event)
                },
              },
            },
            [_vm._v("Login")]
          ),
          _vm._v(" "),
          !_vm.isChrome
            ? _c(
                "div",
                { staticStyle: { "margin-bottom": "20px", color: "#fff" } },
                [
                  _c("i", { staticClass: "el-icon-warning" }),
                  _vm._v(
                    " The Admin portal is optimised on Chrome. Please use Chrome.\n    "
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticStyle: { position: "relative" } }, [
            _c("div", { staticClass: "tips" }, [
              _vm._v("Version: " + _vm._s(_vm.latestNoteVersion)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "tips" }, [
              _vm._v("\n        " + _vm._s(_vm.copyright) + "\n      "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "tips", staticStyle: { "margin-top": "10px" } },
              [
                _c(
                  "a",
                  {
                    staticClass: "lh-login-link",
                    attrs: {
                      href: "https://lifehikes.com/privacy-policy/",
                      target: "_blank",
                      rel: "noopener",
                    },
                  },
                  [_vm._v("Privacy Policy")]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "lh-login-separator" }, [
                  _vm._v("|"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "lh-login-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.openCookieSettings },
                  },
                  [_vm._v("Cookie Settings")]
                ),
              ]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "Or connect with", visible: _vm.showDialog },
          on: {
            "update:visible": function ($event) {
              _vm.showDialog = $event
            },
          },
        },
        [
          _vm._v(
            "\n    Can not be simulated on local, so please combine you own business\n    simulation! ! !\n    "
          ),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("social-sign"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }